import * as yup from 'yup';

const resetPasswordValidation = yup.object().shape({
  password: yup.string()
    .min(4, 'Password must be at least 4 characters long')
    .required('Password is required'),
});

export default resetPasswordValidation;
